import Permission from '@services/Permission';

export const canUserAccess = (role, action, entity) => {
  if (Permission[role] && Permission[role][entity]) {
    let permission = Permission[role][entity];
    if (permission.hasOwnProperty(action)) {
      return permission[action];
    }
    if (permission.hasOwnProperty('default')) {
      return permission.default;
    }
  }

  return true;
};
